export type NewsCategory = "行业动态" | "新片报道" | "明星访谈";

export type NewsItem = {
  id: string;
  title: string;
  category: NewsCategory;
  date: string;
  author: string;
  image: string;
  summary: string;
  content: string[];
};

export const newsCategories: NewsCategory[] = ["行业动态", "新片报道", "明星访谈"];

export const newsList: NewsItem[] = [
  {
    id: "industry-streaming-2025",
    title: "长剧集回归：观众为什么重新愿意花三十个小时",
    category: "行业动态",
    date: "2025-10-15",
    author: "编辑部 · 林深",
    image:
      "https://readdy.ai/api/search-image?query=Editorial%20photograph%20of%20a%20cozy%20living%20room%20at%20night%20with%20a%20glowing%20television%20screen%20showing%20an%20abstract%20deep%20blue%20cinematic%20image%2C%20warm%20amber%20lamp%20beside%20the%20sofa%2C%20film%20grain%20texture%2C%20minimal%20interior%2C%20high%20detail%20magazine%20photography&width=800&height=500&seq=news-streaming-2025&orientation=landscape",
    summary:
      "在短内容持续挤压注意力的当下，一批三十集以上的长剧集反而重新获得了讨论度。我们和三位制片人聊了聊这背后的变化。",
    content: [
      "过去两年，行业里最常被提起的词是「节奏」。几乎每个项目会上都有人问：前三集能不能更快？但今年下半年，几部节奏缓慢、体量不小的长剧集却拿到了意外的口碑与播放曲线。",
      "一位不愿具名的制片人告诉我们，真正的变化发生在观众的观看方式上：「以前大家是碎片时间看剧，现在是主动留出时间。当一部剧值得被认真对待，三十个小时不是门槛，而是理由。」",
      "从制作端看，长剧集也意味着更完整的叙事空间。编剧团队可以有足够的篇幅铺设人物关系，而不是把所有冲突压缩在前六集。这种耐心，正在被市场重新定价。",
      "当然，这并不意味着所有剧都该变长。真正被认可的，是那些「长度与内容匹配」的作品——不注水，也不赶工。",
    ],
  },
  {
    id: "new-film-long-night",
    title: "《长夜将明》定档：一场拍了四十七个雨夜的戏",
    category: "新片报道",
    date: "2025-10-12",
    author: "记者 · 沈知意",
    image:
      "https://readdy.ai/api/search-image?query=Cinematic%20behind%20the%20scenes%20photograph%20of%20a%20rainy%20night%20film%20set%20on%20an%20old%20city%20street%2C%20film%20camera%20under%20an%20umbrella%2C%20wet%20asphalt%20reflecting%20warm%20amber%20street%20lamps%2C%20deep%20navy%20blue%20atmosphere%2C%20soft%20grain%2C%20high%20detail%20editorial%20photography&width=800&height=500&seq=news-long-night-film&orientation=landscape",
    summary:
      "影片公布定档消息的同时，释出一支幕后特辑。导演陈屿提到，全片最重要的那场雨戏，前后拍了四十七个夜晚。",
    content: [
      "《长夜将明》今日正式宣布定档。片方同步释出的幕后特辑中，主创团队还原了那场被称为「全片心脏」的雨夜戏。",
      "导演陈屿在特辑里说，这场戏需要一个几乎没有对白的八分钟长镜头，演员要在真实的暴雨里走完三条街。为了等到合适的雨量，剧组在南方小城驻留了近两个月。",
      "主演张译文提到，最难的不是淋雨，而是「在雨里保持一个人的沉默」。「你不能演悲伤，你只能让观众看见他在想事情。」",
      "影片此前在多个影展放映，口碑集中在影像质感与叙事克制两点。正式上映后，这场雨戏能否成为年度讨论度最高的段落，值得期待。",
    ],
  },
  {
    id: "interview-song-wan",
    title: "专访宋晚：演了三十年山里的老师，我学会了不说话",
    category: "明星访谈",
    date: "2025-10-10",
    author: "记者 · 何砚",
    image:
      "https://readdy.ai/api/search-image?query=Editorial%20portrait%20of%20a%20middle%20aged%20Asian%20actress%20sitting%20by%20a%20window%20in%20soft%20natural%20light%2C%20calm%20expression%2C%20dark%20navy%20clothing%20against%20warm%20neutral%20wall%2C%20shallow%20depth%20of%20field%2C%20film%20grain%2C%20high%20detail%20magazine%20photography&width=800&height=500&seq=news-interview-songwan&orientation=landscape",
    summary:
      "在《山海之间》里，宋晚几乎用沉默演完了一个女人的半生。我们和她聊了聊表演里的「留白」。",
    content: [
      "采访约在一间安静的排练厅。宋晚比约定时间早到了二十分钟，坐在窗边翻剧本，剧本边缘写满了小字。",
      "谈到《山海之间》里的宋晚老师，她说自己最初并不理解这个人物：「她为什么不走？我一开始一直在问导演这个问题。后来我明白了，她不是不能走，她是舍不得。」",
      "剧中有大量没有台词的长镜头。宋晚说，这是她这些年最想做的事——「把表演往回收。观众不需要你告诉他这个人有多难过，你只要站在那儿，让他自己看见。」",
      "采访结束前，她提到自己最近在学手语。「不是为了角色，就是觉得应该学。」她说这话的时候，语气很轻，像在说一件很普通的事。",
    ],
  },
  {
    id: "industry-festival-winners",
    title: "亚洲影展名单公布：三部华语作品入围主竞赛",
    category: "行业动态",
    date: "2025-10-07",
    author: "编辑部 · 周牧",
    image:
      "https://readdy.ai/api/search-image?query=Editorial%20photograph%20of%20an%20empty%20cinema%20auditorium%20with%20deep%20navy%20seats%20and%20a%20softly%20glowing%20blank%20screen%2C%20warm%20amber%20aisle%20lights%2C%20symmetrical%20composition%2C%20film%20grain%2C%20minimal%20high%20detail%20architectural%20photography&width=800&height=500&seq=news-festival-2025&orientation=landscape",
    summary:
      "本届影展主竞赛单元共入围十八部作品，其中三部来自华语地区，题材集中在家庭与城市记忆。",
    content: [
      "影展组委会于昨日公布完整入围名单。主竞赛单元十八部作品中，三部华语作品分别来自内地、香港与台湾地区。",
      "值得注意的是，三部作品的题材都指向「家庭」：一部讲述三代人的迁徙，一部聚焦旧城改造中的一户人家，另一部则以纪录片形式记录了一间即将关闭的老照相馆。",
      "选片人在发布会上表示，今年收到的作品中，「私人记忆」成为最集中的母题。「当外部世界变得不确定，创作者会回到最初的地方。」",
      "影展将于下月中旬开幕，主竞赛结果在闭幕式公布。",
    ],
  },
  {
    id: "new-film-deep-blue",
    title: "《深蓝纪事》幕后：在三千米深处等一束光",
    category: "新片报道",
    date: "2025-10-04",
    author: "记者 · 陆川",
    image:
      "https://readdy.ai/api/search-image?query=Underwater%20documentary%20photograph%20of%20a%20research%20submersible%20descending%20into%20deep%20dark%20ocean%2C%20faint%20blue%20light%20beam%20cutting%20through%20particles%2C%20deep%20navy%20water%2C%20minimal%20composition%2C%20film%20grain%2C%20high%20detail%20editorial%20photography&width=800&height=500&seq=news-deep-blue-doc&orientation=landscape",
    summary:
      "六集纪录片《深蓝纪事》上线后口碑持续走高。摄制组分享了深海拍摄中那些无法复制的瞬间。",
    content: [
      "《深蓝纪事》第四集中那段生物发光群落的影像，被观众称为「今年最美的一分钟」。但这 60 秒，摄制组等了十一天。",
      "深海拍摄最大的敌人不是压力，而是时间。每次下潜只有几个小时，设备调试、光源布置、等待生物靠近，留给拍摄的窗口往往不足二十分钟。",
      "摄影指导提到，他们最终放弃了强光照明，改用极低亮度的红光：「你越想拍清楚，越拍不到。深海要你安静下来。」",
      "纪录片共六集，目前全部上线。最后一集把镜头从深海转回海面，讨论人类活动对海洋生态的影响。",
    ],
  },
  {
    id: "interview-director-lin",
    title: "导演林知远：我不想拍一个「感动」的故事",
    category: "明星访谈",
    date: "2025-09-29",
    author: "记者 · 苏木",
    image:
      "https://readdy.ai/api/search-image?query=Editorial%20portrait%20of%20an%20Asian%20film%20director%20in%20his%20forties%20standing%20in%20a%20dim%20editing%20room%2C%20monitor%20glow%20on%20his%20face%2C%20deep%20navy%20shadows%20with%20warm%20amber%20practical%20light%2C%20film%20grain%2C%20minimal%20composition%2C%20high%20detail%20magazine%20photography&width=800&height=500&seq=news-interview-director&orientation=landscape",
    summary:
      "《山海之间》收官后，导演林知远第一次完整谈起创作。他说，最难的是克制住自己不去煽情。",
    content: [
      "《山海之间》收官当晚，林知远在社交平台只发了一句话：「谢谢所有留下来的人。」",
      "在采访中，他反复提到「克制」这个词。全剧有至少七处可以拍得很催泪的情节，他全部选择了后退一步：「观众很聪明，你一用力，他就知道你在要他哭。」",
      "谈到选角，他说宋晚是第一个也是唯一的选择。「她身上有一种不解释的气质。这个人物不需要解释，她只需要存在。」",
      "至于是否会有第二季，他笑了笑：「山还在那儿，但故事讲完了。讲完的故事，最好不要回头。」",
    ],
  },
  {
    id: "industry-summer-box-office",
    title: "暑期档观察：中等成本影片如何找到自己的观众",
    category: "行业动态",
    date: "2025-09-24",
    author: "编辑部 · 陈叙",
    image:
      "https://readdy.ai/api/search-image?query=Editorial%20photograph%20of%20a%20cinema%20lobby%20with%20warm%20amber%20lighting%20and%20glowing%20movie%20poster%20light%20boxes%2C%20blurred%20visitors%20in%20motion%2C%20deep%20navy%20shadows%2C%20film%20grain%2C%20minimal%20composition%2C%20high%20detail%20architectural%20photography&width=800&height=500&seq=news-box-office&orientation=landscape",
    summary:
      "没有超级 IP，也没有巨额宣发，几部中等成本影片却跑出了长线曲线。它们的共同点是什么？",
    content: [
      "今年暑期档最值得研究的现象，不是头部影片的票房，而是几部中等成本作品的长线表现。",
      "这些影片的相似之处在于：上映首日排片不高，但次周跌幅明显低于大盘。口碑扩散主要来自观众自发的讨论，而非集中投放。",
      "一位发行负责人总结为「找到对的第一批人」：「你不需要所有人都来看，你需要最先看的那批人愿意说。」",
      "这也给中小成本项目提供了另一种思路：与其追求首日声量，不如把资源放在口碑维护与长线放映上。",
    ],
  },
  {
    id: "new-film-tide-city",
    title: "《潮汐之城》发布正式预告，海边电台成关键场景",
    category: "新片报道",
    date: "2025-09-20",
    author: "记者 · 森川",
    image:
      "https://readdy.ai/api/search-image?query=Cinematic%20photograph%20of%20an%20old%20seaside%20radio%20station%20at%20blue%20hour%2C%20warm%20amber%20light%20glowing%20from%20its%20window%2C%20calm%20dark%20sea%20and%20distant%20coastline%2C%20deep%20navy%20palette%2C%20film%20grain%2C%20minimal%20composition%2C%20high%20detail%20editorial%20photography&width=800&height=500&seq=news-tide-city-trailer&orientation=landscape",
    summary:
      "十二集剧集释出正式预告，海边旧电台成为全剧情感线索的核心场景。",
    content: [
      "《潮汐之城》今日发布正式预告。两分十秒的片段里，几乎全部场景都围绕一座即将拆除的海边旧电台展开。",
      "预告中，女主角每天凌晨播报潮汐时间，听众只有固定的一小群人。这段设定来自编剧的一次真实经历——她曾在海边住过半年，每天靠电台的潮汐播报安排生活。",
      "制作团队为还原场景，在真实的海边搭建了一座一比一的电台内景，所有设备都可实际使用。",
      "剧集共十二集，将于下月上线。",
    ],
  },
  {
    id: "interview-cinematographer",
    title: "摄影指导谈「雾港」：让观众看不清，才是恐怖",
    category: "明星访谈",
    date: "2025-09-16",
    author: "记者 · 诺亚",
    image:
      "https://readdy.ai/api/search-image?query=Editorial%20photograph%20of%20a%20cinematographer%20adjusting%20a%20vintage%20film%20camera%20on%20a%20foggy%20harbour%20pier%2C%20thick%20white%20fog%20and%20dark%20water%2C%20deep%20navy%20tones%20with%20warm%20amber%20lamp%2C%20film%20grain%2C%20minimal%20composition%2C%20high%20detail%20magazine%20photography&width=800&height=500&seq=news-interview-dop&orientation=landscape",
    summary:
      "《雾港疑云》的雾不是后期加的。摄影指导艾略特·万讲述了如何用真实天气完成一部悬疑片。",
    content: [
      "《雾港疑云》全片有超过六成镜头处在浓雾中。摄影指导艾略特·万透露，这些雾几乎全部是真实的。",
      "剧组在北方港口驻扎了三个月，每天根据天气调整拍摄计划。「我们有一个雾表，能见度低于三十米就开拍，高于一百米就收工。」",
      "他坚持不使用强补光：「你一打光，雾就变成了背景板。真正的雾应该是有厚度的，它会吃掉你的轮廓。」",
      "这种拍法让素材量大幅减少，但也带来了影片最独特的质感——观众和角色一样，看不清前方。",
    ],
  },
];

export const featuredNewsId = "industry-streaming-2025";